module.exports = __webpack_public_path__ + "img/btn_destination_input.10612c1c.png";